import { OptionConfiguration, ProductOptionItem, ProductOptionRangeType } from '@pedix-workspace/utils';

export type OptionSelectionRange = { min: number; max: number | null };

export function getOptionSelectionRange(
  option: Pick<OptionConfiguration, 'rangeType' | 'min' | 'max'>,
): OptionSelectionRange {
  const min = option.rangeType === ProductOptionRangeType.ANY ? 0 : option.min ?? 0;

  return { min, max: option.rangeType === ProductOptionRangeType.FIXED ? min : option.max ?? null };
}

export function countSelectedOptionItems(items: Pick<ProductOptionItem, 'quantity'>[]): number {
  return items.reduce((total, item) => total + Math.max(1, item.quantity ?? 1), 0);
}
